import originMixpanel from 'mixpanel-browser';

import { MIXPANEL_ID } from '@/constants/env';

originMixpanel.init(MIXPANEL_ID, { debug: false });
const mixpanel = originMixpanel;
export default mixpanel;
